import { render, staticRenderFns } from "./ListPurchaseLimit.vue?vue&type=template&id=1a1c8c50"
import script from "./ListPurchaseLimit.vue?vue&type=script&lang=js"
export * from "./ListPurchaseLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListPurchaseLimit.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a1c8c50')) {
      api.createRecord('1a1c8c50', component.options)
    } else {
      api.reload('1a1c8c50', component.options)
    }
    module.hot.accept("./ListPurchaseLimit.vue?vue&type=template&id=1a1c8c50", function () {
      api.rerender('1a1c8c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ListPurchaseLimit.vue"
export default component.exports